import { Component, OnInit } from '@angular/core';
import { AuthService } from '@core/services/auth/auth.service';

import '@wdpr/button';

@Component({
  standalone: false,
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    constructor(private authService: AuthService) { }

    ngOnInit() {
        console.log('Calling Login');
        this.authService.login();
    }
}
